export class Controller {

    /** @ngInject */
    constructor(
        Alert,
        $state,
        IdpAuthenticatorsService
        ) {
        this.Alert= Alert;
        this.$state= $state;
        this.IdpAuthenticatorsService = IdpAuthenticatorsService;
    }

    $onInit() {
        if (this.application.idpAuthenticatorId) {
            this.selectedIdpAuthenticatorId = this.application.idpAuthenticatorId;
        } else {
            this.selectedIdpAuthenticatorId = '-1';
        }
    }

    saveIdpAuthenticatorDisabled() {
        return this.isSaving || this.idpAuthenticatorNotModified();
    }

    idpAuthenticatorNotModified() {
        return this.application.idpAuthenticatorId === this.selectedIdpAuthenticatorId || (this.application.idpAuthenticatorId == null && this.selectedIdpAuthenticatorId == -1);
    }

    saveIdpAuthenticator() {
        this.isSaving = true;
        if (this.selectedIdpAuthenticatorId == -1) {
            this.IdpAuthenticatorsService
                .unassignApplications(this.companyId, this.application.idpAuthenticatorId, [this.application.id])
                .then(() => this.Alert('success', 'company.idp-authenticators.assign-to-app.updated'))
                .then(() => this.$state.reload('company.manage-application'))
                .finally(() => this.isSaving = false) 
        } else {
            this.IdpAuthenticatorsService
                .assignApplications(this.companyId, this.selectedIdpAuthenticatorId, [this.application.id])
                .then(() => this.Alert('success', 'company.idp-authenticators.assign-to-app.updated'))
                .then(() => this.$state.reload('company.manage-application'))
                .finally(() => this.isSaving = false)
        }
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/idp-authenticators/app-idp-authenticators.controller.js